// extracted by mini-css-extract-plugin
export default {"fixedWidth":"ViewMember_fixedWidth__fCqZc","section":"ViewMember_section__godLJ"};